import { render, staticRenderFns } from "./BarcodeItemEditDialog.vue?vue&type=template&id=1b544da4&scoped=true&"
import script from "./BarcodeItemEditDialog.vue?vue&type=script&lang=ts&"
export * from "./BarcodeItemEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BarcodeItemEditDialog.vue?vue&type=style&index=0&id=1b544da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b544da4",
  null
  
)

export default component.exports